import { ISynchronizationItemMeta } from 'utils/DexieDBManager';

export const filterAcknowledgementSynchronizationItemsMeta = (synchronizationItemMeta: ISynchronizationItemMeta[]) => {
  return synchronizationItemMeta.filter((item) => Boolean(item?.acknowledgementDocumentVersionsCount));
};
